;(() => {
	const initSlider = (section) => {
		const root = document.currentScript?.parentElement || section || document
		const updateSliderEdgeState = (swiper) => {
			const showcaseWrapper = swiper?.el?.closest('.testimonials__slider-wrapper--showcase')
			if (!showcaseWrapper) return

			showcaseWrapper.classList.toggle('is-beginning', swiper.isBeginning)
			showcaseWrapper.classList.toggle('is-end', swiper.isEnd)
		}

		root.querySelectorAll('.testimonials__slider').forEach((testimonialsSlider) => {
			const isExistingReviewImageSlider = testimonialsSlider.dataset.reviewImageSlider === 'true'
			const isExistingDesktop = window.matchMedia('(min-width: 1200px)').matches
			if (testimonialsSlider.swiper) {
				if (isExistingReviewImageSlider) {
					testimonialsSlider.swiper.destroy(true, true)
				} else {
					return
				}
			}

			const sliderRoot =
				testimonialsSlider.closest('.testimonials__review-image-slider-wrapper') ||
				testimonialsSlider.closest('.testimonials__slider-wrapper') ||
				testimonialsSlider.closest('.testimonials')
			const navigation = sliderRoot?.querySelector('.testimonials__navigation')
			const pagination = sliderRoot?.querySelector('.testimonials__pagination')
			const isReviewImageSlider = testimonialsSlider.dataset.reviewImageSlider === 'true'
			const isDesktop = window.matchMedia('(min-width: 1200px)').matches
			const isMobile = window.matchMedia('(max-width: 749px)').matches

			if (isReviewImageSlider && !isDesktop) {
				resetReviewImageDesktopCarousel(testimonialsSlider)
			}

			if (isReviewImageSlider && isMobile) {
				initReviewImageMobileCarousel(testimonialsSlider, navigation)
				return
			}

			if (isReviewImageSlider) {
				resetReviewImageMobileCarousel(testimonialsSlider)
			}

			if (isReviewImageSlider && isDesktop) {
				initReviewImageDesktopCarousel(testimonialsSlider, navigation)
				return
			}

			const columns = Number(testimonialsSlider.dataset.columns)
			let columns750
			if (columns > 1) columns750 = columns - 1
			else columns750 = columns

			const slidesMobile = Number.parseFloat(testimonialsSlider.dataset.slidesMobile)
			const slidesTablet = Number.parseFloat(testimonialsSlider.dataset.slidesTablet)
			const slidesDesktop = Number.parseFloat(testimonialsSlider.dataset.slidesDesktop)
			const spaceMobile = Number.parseFloat(testimonialsSlider.dataset.spaceMobile)
			const spaceTablet = Number.parseFloat(testimonialsSlider.dataset.spaceTablet)
			const spaceDesktop = Number.parseFloat(testimonialsSlider.dataset.spaceDesktop)
			const hasCenteredTablet = Object.prototype.hasOwnProperty.call(testimonialsSlider.dataset, 'centeredTablet')
			const hasCenteredDesktop = Object.prototype.hasOwnProperty.call(testimonialsSlider.dataset, 'centeredDesktop')
			const centeredSlides = testimonialsSlider.dataset.centered === 'true'
			const centeredSlidesTablet = testimonialsSlider.dataset.centeredTablet === 'true'
			const centeredSlidesDesktop = testimonialsSlider.dataset.centeredDesktop === 'true'
			const loopSlides = testimonialsSlider.dataset.loop === 'true'
			const loopSlidesMobile = testimonialsSlider.dataset.loopMobile === 'true'
			const loopSlidesDesktop = testimonialsSlider.dataset.loopDesktop === 'true'
			const useMobileLoop = loopSlidesMobile && window.matchMedia('(max-width: 749px)').matches
			const useDesktopLoop = loopSlidesDesktop && window.matchMedia('(min-width: 1200px)').matches
			const useLoop = loopSlides || useMobileLoop || useDesktopLoop
			const loopSlideCount = testimonialsSlider.querySelectorAll('.swiper-slide').length
			const enableDragGesture =
				isReviewImageSlider || testimonialsSlider.classList.contains('testimonials__slider--showcase_slider')
			const isShowcaseSlider = testimonialsSlider.classList.contains('testimonials__slider--showcase_slider')
			const initialSlideMobile = Number.parseInt(testimonialsSlider.dataset.initialSlideMobile, 10)
			const initialSlideTablet = Number.parseInt(testimonialsSlider.dataset.initialSlideTablet, 10)
			const initialSlideDesktop = Number.parseInt(testimonialsSlider.dataset.initialSlideDesktop, 10)
			const initialSlide =
				window.matchMedia('(min-width: 1200px)').matches && Number.isFinite(initialSlideDesktop)
					? initialSlideDesktop
					: window.matchMedia('(min-width: 750px)').matches && Number.isFinite(initialSlideTablet)
						? initialSlideTablet
						: Number.isFinite(initialSlideMobile)
							? initialSlideMobile
							: undefined

			let swiperParams = {
				slidesPerView: Number.isFinite(slidesMobile) ? slidesMobile : 1,
				slidesPerGroup: 1,
				spaceBetween: Number.isFinite(spaceMobile) ? spaceMobile : 24,
				centeredSlides,
				loop: useLoop,
				loopAdditionalSlides: useLoop ? loopSlideCount : 0,
				loopedSlides: useLoop ? loopSlideCount : undefined,
				loopPreventsSliding: false,
				allowTouchMove: enableDragGesture,
				simulateTouch: enableDragGesture,
				grabCursor: enableDragGesture,
				touchStartPreventDefault: false,
				threshold: enableDragGesture ? 8 : 0,
				watchOverflow: false,
				observer: true,
				observeParents: true,
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {
					750: {
						slidesPerView: Number.isFinite(slidesTablet) ? slidesTablet : columns750,
						slidesPerGroup: 1,
						spaceBetween: Number.isFinite(spaceTablet) ? spaceTablet : 24,
						centeredSlides: hasCenteredTablet ? centeredSlidesTablet : centeredSlides,
					},
					1200: {
						slidesPerView: Number.isFinite(slidesDesktop) ? slidesDesktop : columns,
						slidesPerGroup: 1,
						spaceBetween: Number.isFinite(spaceDesktop) ? spaceDesktop : 24,
						centeredSlides: hasCenteredDesktop
							? centeredSlidesDesktop
							: hasCenteredTablet
								? centeredSlidesTablet
								: centeredSlides,
					},
				},
			}

			if (testimonialsSlider.dataset.fixedSlideWidth === 'true') {
				swiperParams.slidesPerView = 'auto'
				Object.values(swiperParams.breakpoints).forEach((breakpoint) => {
					breakpoint.slidesPerView = 'auto'
				})
			}

			if (enableDragGesture) {
				bindSliderDragProtection(testimonialsSlider)
			}

			if (isShowcaseSlider) {
				swiperParams.touchEventsTarget = 'container'
				swiperParams.followFinger = true
				swiperParams.touchRatio = 1
				swiperParams.longSwipesRatio = 0.15
				swiperParams.longSwipesMs = 180
			}

			if (Number.isFinite(initialSlide)) swiperParams.initialSlide = initialSlide

			if (
				testimonialsSlider.getAttribute('data-pagination') === 'true' &&
				pagination
			) {
				swiperParams.pagination = {
					el: pagination,
					type: 'bullets',
					clickable: true,
				}
			}

			if (
				testimonialsSlider.getAttribute('data-navigation') === 'true' &&
				navigation
			) {
				swiperParams.navigation = {
					nextEl: navigation.querySelector('.swiper-button-next'),
					prevEl: navigation.querySelector('.swiper-button-prev'),
				}
			}

			const testimonialsSwiper = new Swiper(testimonialsSlider, swiperParams)
			if (isReviewImageSlider) testimonialsSlider.dataset.reviewActiveMode = 'tablet'
			updateSliderEdgeState(testimonialsSwiper)
			testimonialsSwiper.on('slideChange resize reachBeginning reachEnd fromEdge', () => {
				updateSliderEdgeState(testimonialsSwiper)
			})
		})
	}

	const bindReviewSwipeGestures = (slider, callbacks) => {
		if (!slider || !callbacks?.onNext || !callbacks?.onPrev) return

		if (slider._reviewSwipeCleanup) {
			slider._reviewSwipeCleanup()
			delete slider._reviewSwipeCleanup
		}

		let startX = 0
		let deltaX = 0
		let isPointerDown = false
		let activePointerId = null
		const threshold = 36
		const mediaNodes = slider.querySelectorAll('img, picture')

		const onPointerDown = (event) => {
			if (event.pointerType === 'mouse' && event.button !== 0) return
			if (event.pointerType === 'mouse') event.preventDefault()
			startX = event.clientX
			deltaX = 0
			isPointerDown = true
			activePointerId = event.pointerId
			if (typeof slider.setPointerCapture === 'function' && event.pointerId != null) {
				try {
					slider.setPointerCapture(event.pointerId)
				} catch (error) {}
			}
		}

		const onPointerMove = (event) => {
			if (!isPointerDown) return
			if (event.pointerType === 'mouse') event.preventDefault()
			deltaX = event.clientX - startX
		}

		const onPointerUp = (event) => {
			if (!isPointerDown) return
			const finalDelta = deltaX || event.clientX - startX
			isPointerDown = false
			if (
				typeof slider.releasePointerCapture === 'function' &&
				activePointerId != null &&
				slider.hasPointerCapture?.(activePointerId)
			) {
				try {
					slider.releasePointerCapture(activePointerId)
				} catch (error) {}
			}
			activePointerId = null
			if (Math.abs(finalDelta) < threshold) return
			if (finalDelta < 0) callbacks.onNext()
			else callbacks.onPrev()
		}

		const onPointerCancel = () => {
			isPointerDown = false
			deltaX = 0
			activePointerId = null
		}

		const onDragStart = (event) => {
			event.preventDefault()
		}

		slider.style.touchAction = 'pan-y'
		mediaNodes.forEach((node) => {
			node.setAttribute('draggable', 'false')
		})
		slider.addEventListener('dragstart', onDragStart)
		slider.addEventListener('pointerdown', onPointerDown, { passive: false })
		slider.addEventListener('pointermove', onPointerMove, { passive: false })
		slider.addEventListener('pointerup', onPointerUp, { passive: true })
		slider.addEventListener('pointercancel', onPointerCancel, { passive: true })
		slider.addEventListener('pointerleave', onPointerCancel, { passive: true })

		slider._reviewSwipeCleanup = () => {
			slider.removeEventListener('dragstart', onDragStart)
			slider.removeEventListener('pointerdown', onPointerDown)
			slider.removeEventListener('pointermove', onPointerMove)
			slider.removeEventListener('pointerup', onPointerUp)
			slider.removeEventListener('pointercancel', onPointerCancel)
			slider.removeEventListener('pointerleave', onPointerCancel)
		}
	}

	const bindSliderDragProtection = (slider) => {
		if (!slider || slider._sliderDragProtectionBound) return

		const mediaNodes = slider.querySelectorAll('img, picture')
		const onDragStart = (event) => {
			event.preventDefault()
		}

		mediaNodes.forEach((node) => {
			node.setAttribute('draggable', 'false')
		})

		slider.addEventListener('dragstart', onDragStart)
		slider._sliderDragProtectionBound = true
	}

	const resetReviewImageDesktopCarousel = (slider) => {
		if (!slider) return

		const wrapper = slider.querySelector('.swiper-wrapper')
		const slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : []
		const sliderRoot = slider.closest('.testimonials__review-image-slider-wrapper')
		const navigation = sliderRoot?.querySelector('.testimonials__navigation')
		const prevButton = navigation?.querySelector('.swiper-button-prev')
		const nextButton = navigation?.querySelector('.swiper-button-next')

		slider.classList.remove('testimonials__slider--review-carousel')
		wrapper?.classList.remove('testimonials__review-carousel-track')
		if (wrapper) {
			wrapper.style.transform = ''
			wrapper.style.transitionDuration = ''
			wrapper.style.transitionDelay = ''
		}
		slider.style.height = ''
		delete slider.dataset.reviewCarouselInitialized

		slides.forEach((slide) => {
			delete slide.dataset.reviewRelative
			slide.style.width = ''
			slide.style.transform = ''
			slide.style.opacity = ''
			slide.style.pointerEvents = ''
			slide.style.zIndex = ''
			slide.style.marginRight = ''
		})

		if (prevButton?._reviewDesktopClick) {
			prevButton.removeEventListener('click', prevButton._reviewDesktopClick)
			delete prevButton._reviewDesktopClick
		}
		if (nextButton?._reviewDesktopClick) {
			nextButton.removeEventListener('click', nextButton._reviewDesktopClick)
			delete nextButton._reviewDesktopClick
		}
		if (slider._reviewSwipeCleanup) {
			slider._reviewSwipeCleanup()
			delete slider._reviewSwipeCleanup
		}
	}

	const resetReviewImageMobileCarousel = (slider) => {
		if (!slider) return

		const wrapper = slider.querySelector('.swiper-wrapper')
		const slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : []
		const sliderRoot = slider.closest('.testimonials__review-image-slider-wrapper')
		const navigation = sliderRoot?.querySelector('.testimonials__navigation')
		const prevButton = navigation?.querySelector('.swiper-button-prev')
		const nextButton = navigation?.querySelector('.swiper-button-next')

		slider.classList.remove('testimonials__slider--review-mobile-carousel')
		wrapper?.classList.remove('testimonials__review-mobile-track')
		if (wrapper) {
			wrapper.style.transform = ''
			wrapper.style.transitionDuration = ''
			wrapper.style.transitionDelay = ''
		}
		slider.style.height = ''
		delete slider.dataset.reviewMobileCarouselInitialized

		slides.forEach((slide) => {
			delete slide.dataset.reviewRelative
			slide.style.width = ''
			slide.style.transform = ''
			slide.style.opacity = ''
			slide.style.pointerEvents = ''
			slide.style.zIndex = ''
			slide.style.marginRight = ''
		})

		if (prevButton?._reviewMobileClick) {
			prevButton.removeEventListener('click', prevButton._reviewMobileClick)
			delete prevButton._reviewMobileClick
		}
		if (nextButton?._reviewMobileClick) {
			nextButton.removeEventListener('click', nextButton._reviewMobileClick)
			delete nextButton._reviewMobileClick
		}
		if (slider._reviewSwipeCleanup) {
			slider._reviewSwipeCleanup()
			delete slider._reviewSwipeCleanup
		}
	}

	const initReviewImageMobileCarousel = (slider, navigation) => {
		if (!slider || slider.dataset.reviewMobileCarouselInitialized === 'true') return

		const wrapper = slider.querySelector('.swiper-wrapper')
		const slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : []
		const prevButton = navigation?.querySelector('.swiper-button-prev')
		const nextButton = navigation?.querySelector('.swiper-button-next')
		if (!wrapper || slides.length === 0) return

		let activeIndex = Number.parseInt(slider.dataset.initialSlideMobile, 10)
		if (!Number.isFinite(activeIndex)) activeIndex = 0
		activeIndex = ((activeIndex % slides.length) + slides.length) % slides.length

		slider.classList.add('testimonials__slider--review-mobile-carousel')
		wrapper.classList.add('testimonials__review-mobile-track')
		slider.dataset.reviewMobileCarouselInitialized = 'true'
		slider.dataset.reviewActiveMode = 'mobile'

		const getRelativeIndex = (index) => {
			let relative = index - activeIndex
			const half = slides.length / 2
			if (relative > half) relative -= slides.length
			if (relative < -half) relative += slides.length
			return relative
		}

		const updateHeight = () => {
			const visibleHeights = slides
				.filter((slide) => Math.abs(Number(slide.dataset.reviewRelative || 99)) <= 1)
				.map((slide) => slide.offsetHeight)
			const height = Math.max(...visibleHeights, 0)
			if (height > 0) slider.style.height = `${height}px`
		}

		const render = () => {
			const viewportWidth = window.innerWidth || slider.clientWidth
			const sliderLeft = slider.getBoundingClientRect().left
			const gap = 12
			const slideWidth = Math.min(320, viewportWidth)
			const centerLeft = (viewportWidth - slideWidth) / 2 - sliderLeft

			slides.forEach((slide, index) => {
				const relative = getRelativeIndex(index)
				const visible = Math.abs(relative) <= 1
				const x = centerLeft + relative * (slideWidth + gap)

				slide.dataset.reviewRelative = String(relative)
				slide.style.width = `${slideWidth}px`
				slide.style.transform = `translate3d(${x}px, 0, 0)`
				slide.style.opacity = visible ? '1' : '0'
				slide.style.pointerEvents = visible ? 'auto' : 'none'
				slide.style.zIndex = String(10 - Math.abs(relative))
			})

			updateHeight()
			prevButton?.classList.remove('swiper-button-disabled')
			nextButton?.classList.remove('swiper-button-disabled')
			prevButton?.removeAttribute('aria-disabled')
			nextButton?.removeAttribute('aria-disabled')
		}

		prevButton._reviewMobileClick = (event) => {
			event.preventDefault()
			activeIndex = (activeIndex - 1 + slides.length) % slides.length
			render()
		}

		nextButton._reviewMobileClick = (event) => {
			event.preventDefault()
			activeIndex = (activeIndex + 1) % slides.length
			render()
		}

		prevButton?.addEventListener('click', prevButton._reviewMobileClick)
		nextButton?.addEventListener('click', nextButton._reviewMobileClick)
		bindReviewSwipeGestures(slider, {
			onNext: () => {
				activeIndex = (activeIndex + 1) % slides.length
				render()
			},
			onPrev: () => {
				activeIndex = (activeIndex - 1 + slides.length) % slides.length
				render()
			},
		})

		slides.forEach((slide) => {
			slide.querySelectorAll('img').forEach((image) => {
				if (!image.complete) image.addEventListener('load', updateHeight, { once: true })
			})
		})

		render()
		const handleResize = () => {
			if (!window.matchMedia('(max-width: 749px)').matches) {
				window.removeEventListener('resize', handleResize)
				resetReviewImageMobileCarousel(slider)
				initSlider(slider.closest('.testimonials'))
				return
			}
			render()
		}
		window.addEventListener('resize', handleResize)
	}

	const initReviewImageDesktopCarousel = (slider, navigation) => {
		if (!slider || slider.dataset.reviewCarouselInitialized === 'true') return

		const wrapper = slider.querySelector('.swiper-wrapper')
		const slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : []
		const prevButton = navigation?.querySelector('.swiper-button-prev')
		const nextButton = navigation?.querySelector('.swiper-button-next')
		if (!wrapper || slides.length === 0) return

		let activeIndex = Number.parseInt(slider.dataset.initialSlideDesktop, 10)
		if (!Number.isFinite(activeIndex)) activeIndex = 2
		activeIndex = ((activeIndex % slides.length) + slides.length) % slides.length

		slider.classList.add('testimonials__slider--review-carousel')
		wrapper.classList.add('testimonials__review-carousel-track')
		slider.dataset.reviewCarouselInitialized = 'true'
		slider.dataset.reviewActiveMode = 'desktop'

		const getRelativeIndex = (index) => {
			let relative = index - activeIndex
			const half = slides.length / 2
			if (relative > half) relative -= slides.length
			if (relative < -half) relative += slides.length
			return relative
		}

		const updateHeight = () => {
			const visibleHeights = slides
				.filter((slide) => Math.abs(Number(slide.dataset.reviewRelative || 99)) <= 2)
				.map((slide) => slide.offsetHeight)
			const height = Math.max(...visibleHeights, 0)
			if (height > 0) slider.style.height = `${height}px`
		}

		const render = () => {
			const sliderWidth = slider.clientWidth
			const gap = 12
			const slideWidth = Math.min(320, sliderWidth)
			const centerLeft = (sliderWidth - slideWidth) / 2

			slides.forEach((slide, index) => {
				const relative = getRelativeIndex(index)
				const visible = Math.abs(relative) <= 2
				const x = centerLeft + relative * (slideWidth + gap)

				slide.dataset.reviewRelative = String(relative)
				slide.style.width = `${slideWidth}px`
				slide.style.transform = `translate3d(${x}px, 0, 0)`
				slide.style.opacity = visible ? '1' : '0'
				slide.style.pointerEvents = visible ? 'auto' : 'none'
				slide.style.zIndex = String(10 - Math.abs(relative))
			})

			updateHeight()
			prevButton?.classList.remove('swiper-button-disabled')
			nextButton?.classList.remove('swiper-button-disabled')
			prevButton?.removeAttribute('aria-disabled')
			nextButton?.removeAttribute('aria-disabled')
		}

		prevButton._reviewDesktopClick = (event) => {
			event.preventDefault()
			activeIndex = (activeIndex - 1 + slides.length) % slides.length
			render()
		}

		nextButton._reviewDesktopClick = (event) => {
			event.preventDefault()
			activeIndex = (activeIndex + 1) % slides.length
			render()
		}

		prevButton?.addEventListener('click', prevButton._reviewDesktopClick)
		nextButton?.addEventListener('click', nextButton._reviewDesktopClick)
		bindReviewSwipeGestures(slider, {
			onNext: () => {
				activeIndex = (activeIndex + 1) % slides.length
				render()
			},
			onPrev: () => {
				activeIndex = (activeIndex - 1 + slides.length) % slides.length
				render()
			},
		})

		slides.forEach((slide) => {
			slide.querySelectorAll('img').forEach((image) => {
				if (!image.complete) image.addEventListener('load', updateHeight, { once: true })
			})
		})

		render()
		const handleResize = () => {
			if (!window.matchMedia('(min-width: 1200px)').matches) {
				window.removeEventListener('resize', handleResize)
				resetReviewImageDesktopCarousel(slider)
				initSlider(slider.closest('.testimonials'))
				return
			}
			render()
		}
		window.addEventListener('resize', handleResize)
	}

	const initReviewImageResponsiveMode = () => {
		let resizeTimer

		window.addEventListener('resize', () => {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(() => {
				document.querySelectorAll('[data-review-image-slider="true"]').forEach((slider) => {
					const targetMode = window.matchMedia('(min-width: 1200px)').matches
						? 'desktop'
						: window.matchMedia('(max-width: 749px)').matches
							? 'mobile'
							: 'tablet'
					if (slider.dataset.reviewActiveMode === targetMode) return

					if (slider.swiper) slider.swiper.destroy(true, true)
					resetReviewImageDesktopCarousel(slider)
					delete slider.dataset.reviewActiveMode
					initSlider(slider.closest('.testimonials') || document)
				})
			}, 120)
		})
	}

	const initMarqueeDesktop = (section) => {
		let testimonialsMarquee
		const root = document.currentScript?.parentElement || section || document

		testimonialsMarquee = root.querySelectorAll('.testimonials__marquee-swiper')

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				const slides = slider.querySelectorAll('.swiper-slide')
				let sum = 0
				slides.forEach((slide) => {
					slide.style.height = slide.clientHeight + 'px'
					sum = sum + slide.clientHeight + 24
				})
				sum = sum - 24

				if (slides.length > 0) {
					let i = 0
					while (sum < slider.clientHeight * 2) {
						if (i > slides.length - 1) {
							i = 0
						}
						let clone = slider
							.querySelectorAll('.swiper-slide')
							[i].cloneNode(true)
						slider.querySelector('.swiper-wrapper').append(clone)
						i++
						sum = sum + clone.clientHeight + 24
					}
				}

				const testimonialsMarqueeSlider = new Swiper(slider, {
					slidesPerView: 'auto',
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initMarqueeMobile = (section) => {
		let testimonialsMarquee
		const root = document.currentScript?.parentElement || section || document

		testimonialsMarquee = root.querySelectorAll(
			'.testimonials__marquee-swiper_mobile'
		)

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				const testimonialsMarqueeSlider = new Swiper(slider, {
					slidesPerView: 3,
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initSection = (section) => {
		const sectionTestimonials = document.currentScript?.parentElement || section || document

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width > 989) {
				const sliders = entry.target.querySelectorAll(
					'.testimonials__marquee-swiper'
				)
				if (sliders.length != 0) {
					sliders.forEach((slider) => {
						if (slider.swiper) slider.swiper.destroy()
					})
				}

				initMarqueeDesktop(sectionTestimonials)
			} else {
				const sliderMobile = entry.target.querySelector(
					'.testimonials__marquee-swiper_mobile'
				)
				if (sliderMobile) {
					if (sliderMobile.swiper) sliderMobile.swiper.destroy()
				}

				initMarqueeMobile(sectionTestimonials)
			}
		})

		sectionResizeObserver.observe(sectionTestimonials)
	}

	initSlider()
	initReviewImageResponsiveMode()
	initMarqueeDesktop()
	initMarqueeMobile()
	initSection()

	document.addEventListener('shopify:section:load', function (section) {
		initSlider(section.target)
		initMarqueeDesktop(section.target)
		initMarqueeMobile(section.target)
		initSection(section.target)
	})
})()
